import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { AltTextPipe } from 'render/render-shared/alt-text/alt-text.pipe';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { LazyLoadModule } from 'shared/lazy-load/lazy-load.module';
import { SharedModule } from 'shared/shared.module';

import { PieceImageTextRenderComponent } from './piece-image-text-render.component';


export const pieceImageTextRenderModuleEntryComponents = [
  PieceImageTextRenderComponent
];

@NgModule({
  imports: [
    AltTextPipe,
    LazyLoadModule,
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule
  ],
  declarations: pieceImageTextRenderModuleEntryComponents,
  exports: [PieceImageTextRenderComponent]
})
export class PieceImageTextRenderModule {}

export default pieceImageTextRenderModuleEntryComponents;
